<div class="content dark">
	<div class="form-group row">
		<label class="col-md-4">OBCU Serial Number:</label>
		<div class="col-md-8">{{asset.obcu_serial_number}}</div>
	</div>
	<div class="form-group row">
		<label class="col-md-4">Configuration Type:</label>
		<div class="col-md-8">
			<select [(ngModel)]="asset.asset_type_id" class="form-control">
				<option *ngFor="let config of orgConfigs" [ngValue]="config.asset_type_id">{{config.asset_type_name}}</option>
			</select>
		</div>
	</div>
	<div class="form-group row">
		<label class="col-md-4">Asset name</label>
		<div class="col-md-8">
			<input [(ngModel)]="asset.asset_name" type="text" class="form-control">
		</div>
	</div>
	<div class="form-group row">
		<label class="col-md-4">SIM card ICCID</label>
		<div class="col-md-8">
			<input [(ngModel)]="asset.sim_iccid" maxlength="64" type="text" class="form-control">
		</div>
	</div>
	<div class="form-group row">
		<label class="col-md-4">MAC address</label>
		<div class="col-md-8">
			<input [(ngModel)]="asset.mac_address" maxlength="64" type="text" class="form-control">
		</div>
	</div>
	<div class="form-group row">
		<label class="col-md-4">Board revision</label>
		<div class="col-md-8">
			<input [(ngModel)]="asset.board_revision" maxlength="64" type="text" class="form-control">
		</div>
	</div>
	<div class="form-group row">
		<label class="col-md-4">Gone Dark alert after x days (0 for none):</label>
		<div class="col-md-8">
			<input [(ngModel)]="asset.gonedark_days" type="number" class="form-control">
		</div>
	</div>
	<div class="form-group row">
		<label class="col-md-4">Suspend gone dark alerts until next active operation:</label>
		<div class="col-md-8">
			<input [(ngModel)]="asset.gonedark_suspend" type="checkbox" class="form-check-input">
		</div>
	</div>
	<div class="form-group row">
		<label class="col-md-4">Hidden from dashboard:</label>
		<div class="col-md-8">
			<input [(ngModel)]="asset.hidden" type="checkbox" class="form-check-input">
		</div>
	</div>
	<div class="form-group row">
		<div class="col-md-8 offset-md-4">
			<app-action-button [action]="UpdateAsset" [context]="this" processing="Updating..." complete="Asset updated" btnClass="btn-primary">Update Asset
			</app-action-button>
		</div>
	</div>
</div>